module.exports = __webpack_public_path__ + "img/sub-cat-relations.13dbd3ee.svg";